import React from "react";

import { useNavigate } from "react-router-dom";
import ListItems from "./ListItems";
import Loading from "../../shared/Loading";

export default function DataTable({
  dataList,
  createButtonLink,
  createButtonText,
  title,
  columns,
  operationLink,
  loading,
}) {
  const navigate = useNavigate();

  if (loading) {
    return <Loading />; // Loading komponens megjelenítése betöltés közben
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header pb-0 card-no-border pb-3 ml-3">
              <h3>{title}</h3>
              <button
                className="btn btn-primary buttons-collection mt-3"
                aria-controls="multilevel-btn"
                aria-haspopup="true"
                onClick={() => navigate(createButtonLink)}
              >
                <span>{createButtonText}</span>
              </button>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="display">
                  <thead>
                    <tr>
                      {columns?.map((i) => {
                        return <th key={i.id}>{i.label}</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    <ListItems
                      data={dataList}
                      columns={columns}
                      operationLink={operationLink}
                    />
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
